import { render } from "./_background.vue?vue&type=template&id=af40386e"
import script from "./_background.vue?vue&type=script&lang=js"
export * from "./_background.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__